import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../utils/contants";

export const FilterStyled = styled.div`
  padding: 12px 36px;
  position: sticky;
  top: 108px;
  z-index: 100;
  background-color: white;
  min-width: 0;

  &.no-padding-border {
    border-bottom: none;
    padding: 0;
    width: 100%;
  }

  button {
    min-width: fit-content;
  }

  .filter-head {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    margin-top: 1px;
  }

  .left-controls,
  .right-controls {
    display: flex;
    gap: 10px;
  }

  .left-controls {
    overflow-x: auto;
  }

  .btn {
    display: flex;
    gap: 8px;
  }

  .selections {
    display: flex;
    gap: 8px;
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .drawer {
    /* height: 415px; */
    background-color: white;
    position: absolute;
    z-index: 10;
    width: 100%;
    top: -800px;
    left: 0;
    border-bottom: 1px solid var(--flow-30-neutral-2, #dedafb);
    /* box-shadow: 0px 4px 8px -2px rgba(0, 0, 0, 0.1),
      0px 2px 4px -2px rgba(0, 0, 0, 0.06); */
  }

  .filter-lists {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    overflow-y: auto;
    height: 300px;

    .filter {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
  }

  .options {
    max-width: 300px;
    height: 100%;
  }

  .border-apply {
    border-left: 1px solid #dedafb;
  }

  .visible {
    top: 45px;
    /* overflow-y: scroll; */
  }

  .title {
    font-size: 13px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 13px;
  }

  .option-flex {
    display: flex;
    align-items: center;

    .MuiButtonBase-root {
      padding: 0px 7px;
    }
    .MuiFormControlLabel-root {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  .apply {
    display: flex;
    justify-content: end;
    gap: 8px;
    margin: 12px 0;
  }

  .divider {
    width: 100%;
    border-color: ${COLOUR_CONSTANT.theme.purple.dark};
  }
`;
